import type { RouteObject } from 'react-router';

import { ContactPage } from './Contact';

/**
 * `/pages/contact`.
 *
 * **Reached from `/pages/about`'s two-entry strip, not from the navigation
 * column.** §20.17 names both pages in one row, so the column carries one entry
 * for the pair; the strip is what keeps this route reachable, and a route no
 * surface links is a route that does not exist for a reviewer.
 */
export const contactRoute: RouteObject = {
  path: 'pages/contact',
  element: <ContactPage />,
};
